export default defineTemplateMeta({
  middleware: ['isn-auth', 'my-account'],
})
